// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.global-loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 99999;
  transition: opacity 0.3s ease;
}
.global-loader-container.active {
  pointer-events: auto;
}

/* --- Route Progress Bar --- */
.route-progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.1);
  overflow: hidden;
  opacity: 0;
  transform: translateY(-4px);
  transition: opacity 0.3s, transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 100000;
}
.route-progress-bar.show {
  opacity: 1;
  transform: translateY(0);
}
.route-progress-bar .progress-line {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, var(--nav_bar_primary_color, maroon), var(--nav_bar_secondary_color, #c0392b), var(--nav_bar_primary_color, maroon));
  background-size: 200% 100%;
  animation: routeProgress 1.5s infinite linear;
}

@keyframes routeProgress {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
/* --- API Overlay Loader --- */
.api-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  animation: fadeIn 0.3s ease-out;
}
.api-overlay .modern-spinner {
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.api-overlay .spinner-circle {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid rgba(var(--nav_bar_primary_color_rgb, 139, 0, 0), 0.1);
  border-top-color: var(--nav_bar_primary_color, maroon);
  border-radius: 50%;
  animation: spin 1s infinite cubic-bezier(0.5, 0.1, 0.4, 0.9);
}
.api-overlay .spinner-logo {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  padding: 2px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: pulse 1.5s infinite alternate ease-in-out;
}
.api-overlay .spinner-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.api-overlay .loading-text {
  font-size: 15px;
  font-weight: 700;
  color: var(--nav_bar_primary_color, maroon);
  letter-spacing: 1px;
  text-transform: uppercase;
  animation: textPulse 1.5s infinite alternate ease-in-out;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  from {
    transform: scale(1);
    opacity: 0.9;
  }
  to {
    transform: scale(1.1);
    opacity: 1;
  }
}
@keyframes textPulse {
  from {
    opacity: 0.5;
    transform: translateY(0);
  }
  to {
    opacity: 1;
    transform: translateY(-2px);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Responsive adjustments */
@media (max-width: 768px) {
  .api-overlay {
    background: rgba(255, 255, 255, 0.85);
    /* Slightly more opaque on mobile */
  }
  .api-overlay .modern-spinner {
    width: 70px;
    height: 70px;
  }
  .api-overlay .spinner-logo {
    width: 40px;
    height: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,6BAAA;AACJ;AACI;EACI,oBAAA;AACR;;AAGA,+BAAA;AACA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;EACA,gBAAA;EACA,UAAA;EACA,2BAAA;EACA,qEAAA;EACA,eAAA;AAAJ;AAEI;EACI,UAAA;EACA,wBAAA;AAAR;AAGI;EACI,WAAA;EACA,YAAA;EACA,uJAAA;EAIA,0BAAA;EACA,6CAAA;AAJR;;AAQA;EACI;IACI,2BAAA;EALN;EAQE;IACI,4BAAA;EANN;AACF;AASA,+BAAA;AACA;EACI,kBAAA;EACA,QAAA;EACA,oCAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,+BAAA;AAPJ;AASI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPR;AAUI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,wEAAA;EACA,sDAAA;EACA,kBAAA;EACA,4DAAA;AARR;AAWI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,0CAAA;EACA,oDAAA;AATR;AAWQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AATZ;AAaI;EACI,eAAA;EACA,gBAAA;EACA,2CAAA;EACA,mBAAA;EACA,yBAAA;EACA,wDAAA;AAXR;;AAeA;EACI;IACI,yBAAA;EAZN;AACF;AAeA;EACI;IACI,mBAAA;IACA,YAAA;EAbN;EAgBE;IACI,qBAAA;IACA,UAAA;EAdN;AACF;AAiBA;EACI;IACI,YAAA;IACA,wBAAA;EAfN;EAkBE;IACI,UAAA;IACA,2BAAA;EAhBN;AACF;AAmBA;EACI;IACI,UAAA;EAjBN;EAoBE;IACI,UAAA;EAlBN;AACF;AAqBA,2BAAA;AACA;EACI;IACI,qCAAA;IACA,mCAAA;EAnBN;EAqBM;IACI,WAAA;IACA,YAAA;EAnBV;EAsBM;IACI,WAAA;IACA,YAAA;EApBV;AACF","sourcesContent":[".global-loader-container {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    pointer-events: none;\r\n    z-index: 99999;\r\n    transition: opacity 0.3s ease;\r\n\r\n    &.active {\r\n        pointer-events: auto;\r\n    }\r\n}\r\n\r\n/* --- Route Progress Bar --- */\r\n.route-progress-bar {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 4px;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    overflow: hidden;\r\n    opacity: 0;\r\n    transform: translateY(-4px);\r\n    transition: opacity 0.3s, transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n    z-index: 100000;\r\n\r\n    &.show {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n\r\n    .progress-line {\r\n        width: 100%;\r\n        height: 100%;\r\n        background: linear-gradient(90deg,\r\n                var(--nav_bar_primary_color, maroon),\r\n                var(--nav_bar_secondary_color, #c0392b),\r\n                var(--nav_bar_primary_color, maroon));\r\n        background-size: 200% 100%;\r\n        animation: routeProgress 1.5s infinite linear;\r\n    }\r\n}\r\n\r\n@keyframes routeProgress {\r\n    0% {\r\n        background-position: 200% 0;\r\n    }\r\n\r\n    100% {\r\n        background-position: -200% 0;\r\n    }\r\n}\r\n\r\n/* --- API Overlay Loader --- */\r\n.api-overlay {\r\n    position: absolute;\r\n    inset: 0;\r\n    background: rgba(255, 255, 255, 0.7);\r\n    backdrop-filter: blur(4px);\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 20px;\r\n    animation: fadeIn 0.3s ease-out;\r\n\r\n    .modern-spinner {\r\n        position: relative;\r\n        width: 80px;\r\n        height: 80px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    .spinner-circle {\r\n        position: absolute;\r\n        width: 100%;\r\n        height: 100%;\r\n        border: 3px solid rgba(var(--nav_bar_primary_color_rgb, 139, 0, 0), 0.1);\r\n        border-top-color: var(--nav_bar_primary_color, maroon);\r\n        border-radius: 50%;\r\n        animation: spin 1s infinite cubic-bezier(0.5, 0.1, 0.4, 0.9);\r\n    }\r\n\r\n    .spinner-logo {\r\n        width: 45px;\r\n        height: 45px;\r\n        border-radius: 50%;\r\n        overflow: hidden;\r\n        background: #fff;\r\n        padding: 2px;\r\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n        animation: pulse 1.5s infinite alternate ease-in-out;\r\n\r\n        img {\r\n            width: 100%;\r\n            height: 100%;\r\n            object-fit: contain;\r\n        }\r\n    }\r\n\r\n    .loading-text {\r\n        font-size: 15px;\r\n        font-weight: 700;\r\n        color: var(--nav_bar_primary_color, maroon);\r\n        letter-spacing: 1px;\r\n        text-transform: uppercase;\r\n        animation: textPulse 1.5s infinite alternate ease-in-out;\r\n    }\r\n}\r\n\r\n@keyframes spin {\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@keyframes pulse {\r\n    from {\r\n        transform: scale(1);\r\n        opacity: 0.9;\r\n    }\r\n\r\n    to {\r\n        transform: scale(1.1);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes textPulse {\r\n    from {\r\n        opacity: 0.5;\r\n        transform: translateY(0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(-2px);\r\n    }\r\n}\r\n\r\n@keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n    .api-overlay {\r\n        background: rgba(255, 255, 255, 0.85);\r\n        /* Slightly more opaque on mobile */\r\n\r\n        .modern-spinner {\r\n            width: 70px;\r\n            height: 70px;\r\n        }\r\n\r\n        .spinner-logo {\r\n            width: 40px;\r\n            height: 40px;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
